export default __webpack_public_path__ + "static/media/DNo.39-3.c8267278.jpg";